
import Header from '../components/Header'
import Breadcrumb from "../components/Breadcrumb";
import Footer from '../components/Footer';
const Patrons = () => {
    return(
        <>
            <Header/>
            <Breadcrumb pageTitle="Our Patrons" mid="About" breadcrumbName="Our Patrons" />
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <h3 className="sub-title">Our Patrons</h3>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='patrons'>
                            <img src='/Images/Pope-Francis.jpg' className='img-fluid' />
                            <div className="patrons-cont">
                            <p>His Holiness Pope Francis</p>
                            <p><span>Supreme Pontiff of Catholic Church</span></p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='patrons'>
                            <img src='/Images/Raphel-Thattil.jpg' className='img-fluid' />
                            <div className="patrons-cont">
                            <p>His Beatitude Mar. Raphel Thattil</p>
                            <p><span>Major Archbishop, Syro Malabar Church</span></p></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='patrons'>
                            <img src='/Images/George-Alencherry.jpg' className='img-fluid' />
                            <div className="patrons-cont">
                            <p>Cardinal Mar. George Alencherry (Emeritus)</p>
                            </div>
                            
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='patrons'>
                            <img src='/Images/Joseph-Perumthottam.jpg' className='img-fluid' />
                            <div className="patrons-cont">
                            <p>His Grace Mar. Joseph Perumthottam</p>
                            <p><span>Archbishop of Changanacherry</span></p></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='patrons'>
                            <img src='/Images/Raphy-Manjaly.jpg' className='img-fluid' />
                            <div className="patrons-cont">
                            <p>His Excellency Mar. Raphy Manjaly</p>
                            <p><span>Archbishop of Agra</span></p></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='patrons'>
                            <img src='/Images/Thomas-Tharayil.jpg' className='img-fluid' />
                            <div className="patrons-cont">
                            <p>His Excellency Mar. Thomas Tharayil</p>
                            <p><span>Auxiliary Bishop of Changanacherry</span></p></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='patrons'>
                            <img src='/Images/Thomas-Padiyath.jpg' className='img-fluid' />
                            <div className="patrons-cont">
                            <p>His Excellency Mar. Thomas Padiyath</p>
                            <p><span>Auxiliary Bishop of Shamshabad</span></p></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='patrons'>
                            <img src='/Images/Thomas-Ezhikkadu.jpg' className='img-fluid' />
                            <div className="patrons-cont">
                            <p>Fr. Thomas Ezhikkadu</p>
                            <p><span>Mission Superior, Etawah - Rajasthan Region</span></p></div>
                        </div>
                    </div>

                </div> 
            </div>
            <Footer />
        </>
    )
}
export default Patrons